/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<Response>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<Response>> => {
  return axios.request({
    url: `/trusted-devices/${encodeURIComponent(request.path['deviceId'] as any)}/deny`,
    // @ts-ignore for sm-axios
    urlTemplate: '/trusted-devices/{deviceId}/deny',
    method: 'POST',
    headers: request.headers,
    data: request.body,
  })
}

/**
 * Denies a trusted device registration, deletes confirmation and revokes session
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<Response>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<Response> => {
  return (await operationWithAxiosResponse(axios, request)).data
}

export interface Request {
  headers?: {
    'x-sm-trace-token'?: string
  }
  path: {
    deviceId: string
  }
  body: {
    /**
     * The email of the user denying the trusted device.
     */
    email: string
    /**
     * UUID of the confirmation request to deny.
     */
    confirmationId: string
  }
}

export type Response =
  | {
      /**
       * UUID of the denied device.
       */
      deviceId: string
    }
  | {
      /**
       * Error code when the confirmation has expired or has already been actioned.
       */
      code: 'TrustedDeviceConfirmationExpired' | 'TrustedDeviceAlreadyActioned'
    }

